import styled from 'styled-components';

export const StyledList = styled.ol`
    text-align: left;
    list-style-position: outside;
    padding-left: 10px;
    line-height: 24px;

    li {
        padding-left: 2px;

        &:last-child {
            margin-bottom: 0;
        }

        b {
            font-weight: 700;
        }

        &::marker {
            font-weight: bold;
        }
    }
`;
